module.exports = __webpack_public_path__ + "static/media/10_2.03b43a42.png";